import type {
  CheckboxChangeEvent as PrimeReactCheckboxChangeEvent,
  CheckboxProps as PrimeReactCheckboxProps
} from 'primereact/checkbox'
import { Checkbox as PrimeReactCheckbox } from 'primereact/checkbox'
import { useId } from 'react'
import './checkbox.css'

export interface CheckboxChangeEvent {
  checked: boolean
  name: string
  value: string
}

interface CheckboxProps extends Omit<PrimeReactCheckboxProps, 'onChange'> {
  label?: string
  onChange?: (event: CheckboxChangeEvent) => void
}

function Checkbox(props: CheckboxProps) {
  const { label, name, onChange, ...rest } = props
  const id = useId()

  const onCheckboxChange = (event: PrimeReactCheckboxChangeEvent) => {
    onChange?.({
      name: name || event.target.name,
      value: event.target.value,
      checked: event.checked ?? false
    })
  }

  return (
    <div className='checkbox-container'>
      <PrimeReactCheckbox {...rest} onChange={onCheckboxChange} inputId={id} name={name} className='tms' />
      <label htmlFor={id} className='checkbox-label'>
        {label}
      </label>
    </div>
  )
}

export default Checkbox
